<h1 class="mb-4">
  <mdb-icon fas icon="cog"></mdb-icon> Productos Anualizado
</h1>
<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Reportes y Consultas</span>
      <span> /</span>
      <span class="grey-text">Productos</span>
      <span> /</span>
      <span>Productos Anualizados</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">

      <div class="row mt-2 filtros-body">
        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select label="Año" [options]="optionsYear" placeholder="Año" [filterEnabled]="true"
              formControlName="anno">
            </mdb-select>
          </div>
        </div>
        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsRubro" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Todos" formControlName="listaRubro"></mdb-select>
            <label>Rubro</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsFamilia" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Todos" formControlName="listaFamilia"></mdb-select>
            <label>Familia</label>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body p-1 justify-content-between">
    <div *ngIf="loading" class="w-100 d-block text-center">
      <mdb-spinner *ngIf="loading" spinnerColor="blue"></mdb-spinner>
    </div>
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">SKU</th>
            <th scope="col">Descripción</th>
            <!-- <th scope="col">Formato</th> -->
            <th scope="col">Rubro</th>
            <th scope="col">Familia</th>
            <th scope="col" class="text-right">Ene</th>
            <th scope="col" class="text-right">Feb</th>
            <th scope="col" class="text-right">Mar</th>
            <th scope="col" class="text-right">Abr</th>
            <th scope="col" class="text-right">May</th>
            <th scope="col" class="text-right">Jun</th>
            <th scope="col" class="text-right">Jul</th>
            <th scope="col" class="text-right">Ago</th>
            <th scope="col" class="text-right">Sep</th>
            <th scope="col" class="text-right">Oct</th>
            <th scope="col" class="text-right">Nov</th>
            <th scope="col" class="text-right">Dic</th>
            <th scope="col" class="text-right">Acumulado</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let mov of listaMovimientos">
            <td>{{ mov.sku }}</td>
            <td>{{ mov.descripcion }}</td>
            <!-- <td>{{ mov.formato_nombre }}</td> -->
            <td>{{ mov.rubro_nombre }}</td>
            <td>{{ mov.familia_nombre }}</td>
            <td class="text-right">{{ mov.enero | numerico }}</td>
            <td class="text-right">{{ mov.febrero | numerico }}</td>
            <td class="text-right">{{ mov.marzo | numerico }}</td>
            <td class="text-right">{{ mov.abrir | numerico }}</td>
            <td class="text-right">{{ mov.mayo | numerico }}</td>
            <td class="text-right">{{ mov.junio | numerico }}</td>
            <td class="text-right">{{ mov.julio | numerico }}</td>
            <td class="text-right">{{ mov.agosto | numerico }}</td>
            <td class="text-right">{{ mov.septiembre | numerico }}</td>
            <td class="text-right">{{ mov.octubre | numerico }}</td>
            <td class="text-right">{{ mov.noviembre | numerico }}</td>
            <td class="text-right">{{ mov.diciembre | numerico }}</td>
            <td class="text-right">{{ mov.acumulado | numerico }}</td>
          </tr>
        </tbody>
        <tbody class="blue lighten-5">
          <tr>
            <td class="text-right" colspan="4"><strong>Totales</strong></td>
            <td class="text-right">{{resumen_totales.enero | numerico}}</td>
            <td class="text-right">{{resumen_totales.febrero | numerico}}</td>
            <td class="text-right">{{resumen_totales.marzo | numerico}}</td>
            <td class="text-right">{{resumen_totales.abrir | numerico}}</td>
            <td class="text-right">{{resumen_totales.mayo | numerico}}</td>
            <td class="text-right">{{resumen_totales.junio | numerico}}</td>
            <td class="text-right">{{resumen_totales.julio | numerico}}</td>
            <td class="text-right">{{resumen_totales.agosto | numerico}}</td>
            <td class="text-right">{{resumen_totales.septiembre | numerico}}</td>
            <td class="text-right">{{resumen_totales.octubre | numerico}}</td>
            <td class="text-right">{{resumen_totales.noviembre | numerico}}</td>
            <td class="text-right">{{resumen_totales.diciembre | numerico}}</td>
            <td class="text-right">{{resumen_totales.acumulado | numerico}}</td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<!-- <div class="card mb-2 wow" *ngIf="listaMovimientosAll?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <table class="table table-striped table-hover table-sm align-middle">
      <thead class="grey lighten-2">
        <tr>
          <th scope="col"></th>
          <th scope="col" class="text-tight">Enero</th>
          <th scope="col" class="text-tight">Febrero</th>
          <th scope="col" class="text-tight">Marzo</th>
          <th scope="col" class="text-tight">Abrir</th>
          <th scope="col" class="text-tight">Mayo</th>
          <th scope="col" class="text-tight">Junio</th>
          <th scope="col" class="text-tight">Julio</th>
          <th scope="col" class="text-tight">Agosto</th>
          <th scope="col" class="text-tight">Septiembre</th>
          <th scope="col" class="text-tight">Octubre</th>
          <th scope="col" class="text-tight">Noviembre</th>
          <th scope="col" class="text-tight">Diciembre</th>
          <th scope="col" class="text-tight">Acumulado</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Totales</strong></td>
          <td class="text-tight">{{resumen_totales.enero | numerico}}</td>
          <td class="text-tight">{{resumen_totales.febrero | numerico}}</td>
          <td class="text-tight">{{resumen_totales.marzo | numerico}}</td>
          <td class="text-tight">{{resumen_totales.abrir | numerico}}</td>
          <td class="text-tight">{{resumen_totales.mayo | numerico}}</td>
          <td class="text-tight">{{resumen_totales.junio | numerico}}</td>
          <td class="text-tight">{{resumen_totales.julio | numerico}}</td>
          <td class="text-tight">{{resumen_totales.agosto | numerico}}</td>
          <td class="text-tight">{{resumen_totales.septiembre | numerico}}</td>
          <td class="text-tight">{{resumen_totales.octubre | numerico}}</td>
          <td class="text-tight">{{resumen_totales.noviembre | numerico}}</td>
          <td class="text-tight">{{resumen_totales.diciembre | numerico}}</td>
          <td class="text-tight">{{resumen_totales.acumulado | numerico}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div> -->

<div class="card mb-2 wow" *ngIf="listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="downloadExcelPdf('XLS')">
      Excel
    </button>
  </div>
</div>
